/**
 * @file: 缩放驱动
 * @author: xiaolong.huang@dmall.com
 */

import Transform from '../../interaction/transform';
import Utils from '../../utils/util';
import ShortCutKey from '../../interaction/shortcutkey/index';
import { StageEvent } from '../../message/index';

function stageZoomInit(): void {
    // 缩放事件监听
    zoomEvent();

    // 鼠标缩放
    mouseZoom();

    // 适配画布大小
    beSuitedToStage();

    // 还原缩放比例至1: 1
    zoomResetEvent();
}

function zoomEvent(): void {
    let $win: JQuery<Window> = $(window);

    StageEvent.on('zoomIn', (params) => {
        Transform.zoomIn({
            left: Utils.math($win.width(), 2, '/'),
            top: Utils.math($win.height(), 2, '/'),
        });
    });

    StageEvent.on('zoomOut', (params) => {
        Transform.zoomOut({
            left: Utils.math($win.width(), 2, '/'),
            top: Utils.math($win.height(), 2, '/'),
        });
    });
}

function mouseZoom(): void {
    ShortCutKey.on({
        keyName: 'mousewheel+mousecenter',
        callback: (e) => {
            let wheelDelta: number = e.originalEvent.wheelDelta;

            if (wheelDelta > 0) {
                Transform.zoomOut({
                    left: e.clientX,
                    top: e.clientY
                });
            }
            else {
                Transform.zoomIn({
                    left: e.clientX,
                    top: e.clientY
                });
            }
        }
    });
}

function beSuitedToStage(): void {
    let $win: JQuery<Window> = $(window);

    ShortCutKey.on({
        keyName: '/',
        callback: () => {
            Transform.resizeToStage();
        }
    });
    Transform.resizeToStage();
}

function zoomResetEvent(): void {
    ShortCutKey.on({
        keyName: 'command+number',
        callback: (e) => {
            if (e.keyCode !== 48) {
                return;
            }

            zoomReset();
        }
    });

    ShortCutKey.on({
        keyName: 'ctrl+number',
        callback: (e) => {
            if (e.keyCode !== 48) {
                return;
            }

            zoomReset();
        }
    });
}

function zoomReset(): void {
    let $win: JQuery<Window> = $(window);

    Transform.zoomTo(1, {
        left: Utils.math($win.width(), 2, '/'),
        top: Utils.math($win.height(), 2, '/'),
    });
    Transform.moveTo({
        left: 0,
        top: 200
    });
}

export {
    stageZoomInit
};
